import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { NotificationsModalComponent } from './notifications-modal-component';

export const NotificationsModalModule: string = ng
    .module('notifications-modal-component', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('notificationsModalComponent', NotificationsModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/component/notifications-modal-component/notifications-modal-component.module.ts